import { Router } from '@angular/router';
import { Component, HostBinding, OnInit } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  zoomInAnimation,
  zoomOutAnimation,
} from '../../animations/custom.animations';
import { SiteContentService, SiteSettings } from '../../services/site-content.service';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'inOut',
        style({
          left: '0%',
        })
      ),
      transition('void => *', [style({ left: '-100%' }), animate(300)]),
      transition('* => void', [animate(300, style({ left: '-100%' }))]),
    ]),
    zoomInAnimation,
    zoomOutAnimation,
  ],
})
export class HeaderBarComponent implements OnInit {
  public active_link: string | null = null;
  public onHomePage = false;
  public isMenuOpen = false;
  public menuState = '0';
  public isApprenticeshipOpen = false;
  public isDownloadingFpc = false;
  public settings: SiteSettings = { id: 'global' };
  public fpcUrl = '';

  @HostBinding('@slideInOut') get slideInOut() {
    return 'inOut';
  }

  constructor(
    private router: Router,
    private siteContentService: SiteContentService
  ) { }

  ngOnInit(): void {
    if (this.router.url.startsWith('/accueil')) {
      this.onHomePage = true;
    }

    this.toggleClassMenu(this.router.url);
    this.siteContentService.getSettings().subscribe({
      next: (settings) => { if (settings) this.settings = settings; },
      error: () => undefined,
    });
    this.siteContentService.getDocument('formation-professionnelle-continue').subscribe({
      next: (document) => {
        this.fpcUrl = this.siteContentService.resolveDocumentUrl(
          document,
          'https://cfasante.fr/assets-upload/FPC.pdf'
        );
      },
      error: () => { this.fpcUrl = 'https://cfasante.fr/assets-upload/FPC.pdf'; },
    });
  }

  public toggleApprenticeship(): void {
    this.isApprenticeshipOpen = !this.isApprenticeshipOpen;
  }

  public toggleMenu(): void {
    const menu = document.querySelector('.navbar-menu');
    if (!menu) return;

    if (menu.classList.contains('-translate-x-full')) {
      menu.classList.remove('-translate-x-full');
    } else {
      menu.classList.add('-translate-x-full');
    }
  }

  public toggleClassMenu(link: string): void {
    if (link) {
      this.active_link = link;
    }
  }

  public toggleTrainingsType(): void {
    const menu = document.querySelector('.training-menu');
    if (!menu) return;

    menu.classList.toggle('hidden');
  }

  public toggleTrainingsTypeMobile(): void {
    const menu = document.querySelector('.training-menu-mobile');
    if (!menu) return;

    menu.classList.toggle('hidden');
  }

  public onClick(): void {
    if (this.isDownloadingFpc) return;
    this.isDownloadingFpc = true;
    window.open(this.fpcUrl || 'https://cfasante.fr/assets-upload/FPC.pdf', '_blank', 'noopener,noreferrer');
    this.isDownloadingFpc = false;
  }
}
